import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  type?: "website" | "article" | "book" | "profile";
  image?: string;
  jsonLd?: Record<string, unknown>;
}

const BASE_URL = "https://wranglingchaos.org";
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`;

export function SEO({
  title = "Wrangling Chaos | DN McCier",
  description = "Agency life moves fast. Wrangling Chaos is the no-fluff guide for project managers, creatives, and operators managing projects in advertising with clarity, confidence, and rhythm. By DN McCier.",
  canonical,
  type = "website",
  image = DEFAULT_IMAGE,
  jsonLd,
}: SEOProps) {
  const fullTitle = title.includes("Wrangling Chaos") ? title : `${title} | Wrangling Chaos`;
  const canonicalUrl = canonical ? `${BASE_URL}${canonical}` : BASE_URL;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Wrangling Chaos" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
